import React, { useContext, useEffect, useState } from 'react';
import { Segment } from 'semantic-ui-react';
import { DimmerWrap } from '../../components/alerts/DimmerWrap';
import UiSaveButtons from '../../components/buttons/UiSaveButtons';
import JsonViewer from '../../components/viewers/JsonViewer';
import GenericButton from '../../genericControls/GenericButton';
import Wrapper, { wrapperTypes } from '../../wrappers/Wrapper';
import { ParentContext } from 'global/cnr/contexts/ParentContext';

const allowUpdate = true
const dimmerCaption = 'Fetching'
const WAIT_INTERVAL = 2000

const AppFormsViewer = () => {

  const parentContext = useContext(ParentContext)
  const { fn_cls, fns } = parentContext ?? {}
  const { database_fns } = fns ?? {}

  const [question, setQuestion] = useState()
  const [dbForms, setDbForms] = useState()
  const [functionForms, setFunctionForms] = useState()
  const [saveResult, setSaveResult] = useState()
  const [updating, setUpdating] = useState()

  useEffect(() => {
    if (saveResult) {
      const timer = setTimeout(() => setSaveResult(), WAIT_INTERVAL);
      return () => clearTimeout(timer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [saveResult]);

  useEffect(() => {
    const vvProps = {}
    fn_cls.getAppForms(database_fns, vvProps).then(appForms => {
      setFunctionForms(appForms)
    })
    getAppForms(database_fns, setDbForms)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, []);

  const btnProps = { inverted: true, color: allowUpdate ? 'blue' : 'olive' }

  const handleSaveResult = (sr) => {
    setUpdating()
    setSaveResult(sr)
  }

  const handleSave = () => {
    setUpdating(true)
    saveAppForms(functionForms, handleSaveResult)
  }

  const gb = (key, caption, icon, onClick, clickOptions, opts, noE) => <GenericButton gbProps={{ key, caption, icon, onClick, clickOptions, opts, noE }} />

  const handleQuestion = () => setQuestion(true)
  const saveButton = () => gb('btn-save', 'Update Database from Functions', 'save', handleQuestion, null, { ...btnProps })

  const functionsViewer_simple = () => <JsonViewer keyy={'jvr-1'} json={functionForms} name={'App Forms - Functions'} showButtons={{ 'copy': true }} saveButton={saveButton()} />

  const saveButtons = () => saveResult ?
    <Segment inverted basic>Saved</Segment>
    :
    <UiSaveButtons
      cancel={{ oc: setQuestion, caption: 'Close' }}
      save={{ oc: handleSave, caption: 'Confirm' }}
    />

  const content = () => <div className={'split-container-half'}>
    {functionForms ? functionsViewer_simple() : <DimmerWrap caption={dimmerCaption} />}
    {dbForms ? <JsonViewer keyy={'jvr-2'} json={dbForms} name={'App Forms - Database'} showButtons={{ 'copy': true }} /> : <DimmerWrap caption={dimmerCaption} />}
    {/* {functionForms ? functionsViewer_simple() : <Segment inverted basic>Pending</Segment>} */}
    {/* {dbForms ? <JsonViewer keyy={'jvr-2'} json={dbForms} name={'App Forms - Database'} showButtons={{ 'copy': true }} /> : <Segment inverted basic>Pending</Segment>} */}
  </div>

  const questionWizard = () => <Wrapper
    content={functionsViewer_simple()}
    footer={saveButtons()}
    wrapperType={wrapperTypes.padded}
    updating={updating}
  />

  return question ? questionWizard() : content()
}

const getAppForms = (database_fns, callback) => {
  const docName = '_appForms'
  database_fns.get_data({ refPath: [docName], opts: { ignoreId: true } }).then(data => {
    callback(data)
  }).catch(error => {
    console.error(error);
  })
}

const saveAppForms = (database_fns, appForms, callback) => {
  Object.keys(appForms).forEach(key => {
    const appForm = appForms[key]
    Object.keys(appForm).forEach((keyy, index) => {
      const formItem = appForm[keyy]
      if (formItem) {
        try {
          formItem._position = index
        } catch (error) {
          console.log('error', formItem, error)
        }
      }
    })
  })

  if (allowUpdate) {
    database_fns.set_doc(['_appForms', 'appForms'], appForms, null, callback)
  }
}

export default AppFormsViewer